import { cloneElement, Component } from "preact";
import PropTypes from "prop-types";
import { M_Icons } from "../../models/Models_Icons";
import { combineClasses } from "@green24/npm-javascript-utils";

class Fa extends Component {
	render({className, style, icon}) {
		let svg = M_Icons[icon];
		if(!svg) {
			throw Error("Unknown icon: " + icon);
		}

		//svgr (webpack plugin) exports SVGs as functional components
		if(typeof svg === "function") {
			//Initialize the component so it can be used in the cloneElement()
			svg = svg();
		}

		return cloneElement(
			svg,
			{
				className: combineClasses("fa", "icon-" + icon, className),
				style,
			},
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,

			/**
			 * @type M_Icons
			 */
			icon: PropTypes.oneOf(Object.keys(M_Icons)),
		}
	}
}

export default Fa;
